<template>
  <div>
    <div class="wrapper">
      Thank you for logging in.
      Redirecting you
      <div class="anim-wrapper">
        <div class="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setTimeout } from "timers";
import { mapGetters } from "vuex";
import { AUTH_GET_ME } from "@/store/types";

export default {
  computed: {
    ...mapGetters(["getCurrentUser", "isAuthLoading"])
  },
  data() {
    return {
      errorMessage: "",
      uid: ""
    };
  },
  methods: {
    stripeCheckout() {
      const stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
      stripe
        .redirectToCheckout({
          items: [{ sku: process.env.VUE_APP_STRIPE_PRO_PLAN_ID, quantity: 1 }],
          successUrl: process.env.VUE_APP_STRIPE_CHECKOUT_SUCCESS_REDIRECT_URL,
          cancelUrl: process.env.VUE_APP_STRIPE_CHECKOUT_SUCCESS_CANCEL_URL,
          clientReferenceId: this.uid
        })
        .then(result => {
          if (result.error) {
            this.errorMessage = result.error.message;
          }
        });
    }
  },
  mounted() {
    const doc = document.createElement("script");
    doc.setAttribute("src", "https://js.stripe.com/v3/");
    document.head.appendChild(doc);
    this.uid = this.$route.params.uid;

    setTimeout(() => {
      this.$store.dispatch(AUTH_GET_ME).then(resp => {
        this.stripeCheckout();
      });
    }, 3000);
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  font-size: 22px;
  color: white;
  font-weight: bold;
  margin: 150px auto 350px;
}
.anim-wrapper {
  display: block;
  margin: 0 auto;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}
</style>